"use client";

import { useEffect } from "react";
import { ServiceUnavailable } from "@/components/ServiceUnavailable";

/**
 * Segment error boundary — catches client render errors in the app tree
 * so users see a clear retry UI instead of Next's generic crash message.
 */
export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error("[error]", error);
  }, [error]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-muted/30 p-4">
      <ServiceUnavailable
        title="Something went wrong"
        description="We couldn’t load this page. If our booking service is briefly down, please try again in a moment."
        onRetry={reset}
      />
    </div>
  );
}
